var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'jquery', 'underscore', 'backbone', 'app-common/component/api-call', 'autolinker', 'app-common/component/baseView'], function(core, $, _, Backbone, apiCall, Autolinker, BaseView) {
  var Commenting;
  return Commenting = (function(_super) {

    __extends(Commenting, _super);

    function Commenting() {
      Commenting.__super__.constructor.apply(this, arguments);
    }

    Commenting.prototype.inputSelector = '';

    Commenting.prototype.$getInput = function() {
      return this.$el.find(this.inputSelector);
    };

    Commenting.prototype.setText = function(text) {
      return this.$getInput().text(text);
    };

    Commenting.prototype.getText = function(node) {
      var html, result;
      if (node == null) {
        node = this.$getInput()[0];
      }
      if (node instanceof jQuery) {
        node = node[0];
      }
      if (node.innerText) {
        return node.innerText;
      } else {
        html = node.innerHTML;
        result = html.replace(/<br>/gi, '\n');
        return result.replace(/<\/?[^>]+>/gi, '');
      }
    };

    Commenting.prototype.showSubmit = function(e) {
      return this.$getInput().addClass('highlighted');
    };

    Commenting.prototype.hideSubmit = function() {
      return this.$getInput().removeClass('highlighted');
    };

    Commenting.prototype.formatUrls = function(convo) {
      _.each(convo != null ? convo.comments : void 0, function(cmnt) {
        return cmnt.body = Autolinker.link(_.unescape(cmnt.body));
      });
      return convo;
    };

    Commenting.prototype.allowedToEdit = function(targetAuthorId) {
      return core.getCurrentClientId() === targetAuthorId || core.isCurrentClientBookkeeper();
    };

    Commenting.prototype.updateComment = function(id, date, author, message) {
      var promise,
        _this = this;
      if (id == null) {
        id = this.id;
      }
      promise = apiCall('comments', 'conversation/' + id + '/edit', 'PUT', {
        body: message,
        originalAuthor: author,
        originalDate: date
      }, 'json', 'x-www-form-urlencoded');
      return promise.done(function() {
        return _this.refresh();
      });
    };

    Commenting.prototype.toggleEdit = function(e) {
      var $commentBody, $commentFooter, $target, authorId, date, editingClassName, id;
      editingClassName = 'comments-display--is-editing';
      $target = $(e.currentTarget);
      $commentFooter = $target.closest('.comments-display__footer');
      $commentBody = $commentFooter.siblings('.comments-display__body');
      if (!$commentFooter.hasClass(editingClassName)) {
        $commentFooter.addClass(editingClassName);
        $commentBody.prop('contenteditable', true);
        $commentBody.focus();
        return $commentBody.data('oldVal', $commentBody.html());
      } else {
        $commentFooter.removeClass(editingClassName);
        $commentBody.prop('contenteditable', false);
        id = $commentFooter.data('id') || this.id;
        date = $commentFooter.data('date');
        authorId = $commentFooter.data('author');
        if ($target.hasClass('btn-reply')) {
          return this.updateComment(id, date, authorId, this.getText($commentBody[0]));
        } else {
          $commentBody.html($commentBody.data('oldVal'));
          return $commentBody.removeData('oldVal');
        }
      }
    };

    Commenting.prototype.refresh = function() {
      return this.render();
    };

    return Commenting;

  })(BaseView);
});
